// extracted by mini-css-extract-plugin
module.exports = {"asset_card_details":"AssetCard_asset_card_details__1LF-X","asset_card_img":"AssetCard_asset_card_img__1JhMs","asset_link":"AssetCard_asset_link__3CwXB"};